import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { usePathname } from "@-/com.npmjs.expo-router";
import { NavContext } from "#nav-context";

/** Whether a focused screen has requested the primary navigation strip be hidden. */
export function useIsPrimaryNavigationStripHidden() {
  const [isPrimaryNavigationStripHidden] = useContextSelectors(
    NavContext,
    (c) => c.isPrimaryNavigationStripHidden,
  );
  return isPrimaryNavigationStripHidden;
}

/** Setter for {@link useIsPrimaryNavigationStripHidden} (e.g. `<SlideOptions isPrimaryNavigationStripHidden />`). */
export function useSetIsPrimaryNavigationStripHidden() {
  const [setIsPrimaryNavigationStripHidden] = useContextSelectors(
    NavContext,
    (c) => c.setIsPrimaryNavigationStripHidden,
  );
  return setIsPrimaryNavigationStripHidden;
}

/** Whether a focused screen has requested the primary controls strip's expand/collapse toggle be hidden. */
export function useIsPrimaryControlsStripExpansionButtonHidden() {
  const [isPrimaryControlsStripExpansionButtonHidden] = useContextSelectors(
    NavContext,
    (c) => c.isPrimaryControlsStripExpansionButtonHidden,
  );
  return isPrimaryControlsStripExpansionButtonHidden;
}

/**
 * Setter for {@link useIsPrimaryControlsStripExpansionButtonHidden}
 * (e.g. `<SlideOptions isPrimaryControlsStripExpansionButtonHidden />`).
 */
export function useSetIsPrimaryControlsStripExpansionButtonHidden() {
  const [setIsPrimaryControlsStripExpansionButtonHidden] = useContextSelectors(
    NavContext,
    (c) => c.setIsPrimaryControlsStripExpansionButtonHidden,
  );
  return setIsPrimaryControlsStripExpansionButtonHidden;
}

/**
 * Whether the entire primary controls strip should be hidden, so a full-page screen renders edge-to-edge
 * with no app chrome.
 *
 * The fresh-install welcome/auth gate (`(nav)/auth` index) is such a screen: it lives inside
 * `(nav)` (it needs the `(nav)` database providers) but must show no primary controls strip. Rather than have the
 * The primary controls strip self-hides by inspecting the active route here: the gate's pathname is exactly
 * `/auth` (the `(nav)` group is stripped from the pathname). Pushed auth forms at
 * `/auth/<form>` share this borderless treatment and provide their own back control.
 */
export function useIsPrimaryControlsStripHidden() {
  const pathname = usePathname();
  return pathname === "/auth" || pathname.startsWith("/auth/");
}
